function getCancelReservationState(state) {
  return {
    isLoading: state.cancelReservation.loading,
    fetchResponse: state.cancelReservation.data,
    recievedSuccessfulResponse: state.cancelReservation.recievedSuccessfulResponse,
    recievedErrorResponse: state.cancelReservation.recievedErrorResponse,
    currentPosting: state.cancelReservation.currentPosting
  };
}

export { getCancelReservationState };
